export default "__VITE_PUBLIC_ASSET__6c3f6b94__"